var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTiempoRapido(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 26,
    height: 26,
    rx: 9.5,
    fill: "#F0F1F3",
    stroke: "#9597A7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#666770"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11,
    width: 3,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 13,
    width: 4.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 15,
    width: 6,
    height: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 13.5,
    r: 6,
    fill: "none",
    stroke: "#666770",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 13.5,
    x2: 16,
    y2: 10,
    stroke: "#666770",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 13.5,
    x2: 18.5,
    y2: 15,
    stroke: "#666770",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiempoRapido);
export default __webpack_public_path__ + "static/media/tiempo-rapido.1f5c41d1b5062b8f9f666ec89175a2b6.svg";
export { ForwardRef as ReactComponent };